<template>
  <div class="successCases">
    <Nav></Nav>
    <div class="top-img">
      <img :src="zyly" alt=""/>
    </div>
    <div class="card-info">
      <div class="img-grid">
      <div
        v-for="(item, index) in imgList"
        :key="index"
        class="img-item"
      >
        <img :src="item.img" :alt="item.text">
          <p class="img-text">{{ item.text }}</p>
        </div>
      </div>
    </div>
    <footer-con/>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import zyly from '@/assets/img/zyly.png'
import FooterCon from '@/components/footer-con'
import qyflyz from '@/assets/professionalField/qyflyz.png'
import mssss from '@/assets/professionalField/mssss.png'
import blzccz from '@/assets/professionalField/blzccz.png'
import zscqwq from '@/assets/professionalField/zscqwq.png'
import jrzq from '@/assets/professionalField/jrzq.png'
import hyjs from '@/assets/professionalField/hyjs.png'
import jdjf from '@/assets/professionalField/jdjf.png'
import bgcz from '@/assets/professionalField/bgcz.png'
import xsbh from '@/assets/professionalField/xsbh.png'
import xzpc from '@/assets/professionalField/xzpc.png'
export default {
  name: "ProfessionalField",
  components: {
    Nav,
    FooterCon,
  },
  data() {
    return {
      zyly,
      imgList:[
        {
          text:'企业法律商务',
          img:qyflyz
        },
        {
          text:'民商事诉讼',
          img:mssss
        },
        {
          text:'不良资产处置',
          img:blzccz
        },
        {
          text:'知识产权维权',
          img:zscqwq
        },
        {
          text:'金融证券',
          img:jrzq
        },
        {
          text:'婚姻家事',
          img:hyjs
        },
        {
          text:'借贷纠纷',
          img:jdjf
        },
        {
          text:'并购重组',
          img:bgcz
        },
        {
          text:'刑事辩护',
          img:xsbh
        },
        {
          text:'行政赔偿',
          img:xzpc
        },
      ]
    };
  },
  created() {},
  mounted() {},
  methods:{
  }
};
</script>

<style lang="scss" scoped>
.successCases{
  height: 100%; /* 确保父容器高度为 100% */
}

.card-info {
  padding: 10vh 10vw;
  background-color: #fff;
}

.img-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 2vw;
}

.img-item {
  flex: 0 0 calc(25% - 1.5vw);
  margin-bottom: 2vh;
  position: relative;

  img {
    width: 100%;
    height: auto;
    display: block;
  }

  .img-text {
    text-align: center;
    margin-top: 10px;
    font-size: 16px;
    color: #fff;
    position: absolute;
    bottom: 16px;
    left: 16px;
  }
}

.top-img{
  width: 100%;

  img{
    width: 100%;
    vertical-align: top;
  }
}
</style>
